"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
window._ = require("lodash");
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
var token = document.head.querySelector('meta[name="csrf-token"]');
if (token)
    window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
window.app = window.app || { locale: "", errors: [], success: [] };
window.app.locale = document.querySelector("html").getAttribute("lang");
window.app.errors = [];
window.app.success = [];
// bootstrap
require("./polyfill");
require("./watermark");
require("./browse-happy");
// controllers
require("@/controllers");
